<template>
  <vue-content-loading :height="300" preserveAspectRatio="none">
    <rect x="0" y="20" rx="4" ry="4" width="200" height="180" />
    <rect x="210" y="40" rx="4" ry="4" width="150" height="20" />
    <rect x="210" y="80" rx="4" ry="4" width="180" height="10" />
    <rect x="210" y="100" rx="4" ry="4" width="180" height="10" />
    <rect x="210" y="120" rx="4" ry="4" width="180" height="10" />
    <rect x="10" y="230" rx="4" ry="4" width="190" height="40" />
    <rect x="210" y="230" rx="4" ry="4" width="180" height="40" />
  </vue-content-loading>
</template>

<script>
import { VueContentLoading } from "vue-content-loading"

export default {
  name: "news-loading-skeleton",
  components: { VueContentLoading }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/homebase/news/NewsLoadingSkeleton.vue